import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "summary-section" }
const _hoisted_2 = { class: "summary-section-content" }
const _hoisted_3 = { class: "xname sc-label" }
const _hoisted_4 = { class: "xtext sc-value" }

import { ref } from "vue";
import { CertificationDetails } from "@/types/certifications";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationDetails',
  props: {
    certificationDetails: {}
  },
  setup(__props: any) {

const props = __props;

const data = ref([
  {
    name: "referenceId",
    label: "Ref Id",
    title: "Reference Id",
    value: props.certificationDetails?.referenceId,
  },
  {
    name: "certificationCreatedDate",
    label: "Cert Created Date",
    title: "Certification Created Date",
    value: props.certificationDetails?.createdDate,
  },
  {
    name: "certificationExpirationDate",
    label: "Cert Exp. Date",
    title: "Certification Expiration Date",
    value: props.certificationDetails?.expirationDate,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "summary-section-header sc-header" }, "Certification Details", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sc-table-details" }, null, -1)),
      _createElementVNode("table", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (field) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: field.name
          }, [
            _createElementVNode("th", _hoisted_3, _toDisplayString(field.label || ""), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(field.value || ""), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})